export enum currencies {
  USD = 'USD',
  UAH = 'UAH',
  EUR = 'EUR',
  ARS = 'ARS',
  MXN = 'MXN',
  BRL = 'BRL',
  COP = 'COP',
  GTQ = 'GTQ',
  INR = 'INR',
  PLN = 'PLN',
  RON = 'RON',
  CAD = 'CAD',
  CZK = 'CZK',
}
